// src/redux/currency/actions.ts
export const SET_CURRENCY = 'SET_CURRENCY';

export const setCurrency = (currency: string) => ({
  type: SET_CURRENCY,
  payload: currency,
});
